module.exports = "/packs/images/components/activities-facilities-panel/background-container~58d2c6cfb0debb6fcb534dccd75e8273.png";